import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import qualityScoreTemplate from './quality-score.pug';

export class QualityScoreColumn extends CampaignuiBaseColumn {
  constructor({ i18n, helpId = 'Page_CampaignGrids_QualScore', isForVNext }) {
    const title = i18n.getString('ColumnName_QualityScore');

    super({
      name: 'QualityScore',
      property: 'QualityScore',
      title,
      sortable: 'QualityScore/OverallQualityScore',
      type: 'string',
      bodyClasses: ['grid-column-QualityScore'],
      helpId,
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });

    this.titleDetail = i18n.getString('Page_Keywords_QualityScoreDetails');
    this.isForVNext = isForVNext;
  }

  pickProperty(item) {
    return _.defaults({
      score: item && item.QualityScore && item.QualityScore.OverallQualityScore,
      title: this.titleDetail,
    });
  }

  template(model) {
    return qualityScoreTemplate(_.extend({
      isForVNext: this.isForVNext,
    }, model));
  }
}
